import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { BreakdownReasonService } from '../../../../../services/table-management/breakdownReason.service';
import { BreakdownReasonFormComponent } from '../breakdown-reason-form/breakdown-reason-form.component';

@Component({
  selector: 'app-breakdown-reason-list',
  templateUrl: './breakdown-reason-list.component.html',
  styleUrls: ['./breakdown-reason-list.component.css'],
  providers:[BreakdownReasonService, ConfirmationService, UserTimePipe, ExcelService],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BreakdownReasonListComponent extends EntityListComponent<Rest.InvBreakdownReason>
  implements OnInit {

  @ViewChild(BreakdownReasonFormComponent, { static: true })
    breakdownReasonForm: BreakdownReasonFormComponent;
  
    title: string = this.translateService.instant('tableManagement.breakdown.breakdownReason.title');
    disableSave: boolean;
    EnabledFilter: SelectItem[];
    isCreateGranted: boolean;
    isDisabledGranted: boolean;
  
    constructor(
      private breakdownReasonService: BreakdownReasonService,
      protected confirmationService: ConfirmationService,
      public notificationsService: NotificationsService,
      protected i18n: I18nService,
      authenticationService: AuthenticationService,
      protected loadingService: LoadingService,
      protected userTime: UserTimePipe,
      protected excelService: ExcelService,
      protected translateService: TranslateService,
    ) {
      super(
        breakdownReasonService,
        confirmationService,
        notificationsService,
        i18n,
        authenticationService,
        loadingService,
        userTime,
        excelService
      );
      this.breakdownReasonService = breakdownReasonService;
    }
  
    ngOnInit() {
      super.ngOnInit();
      this.form = this.breakdownReasonForm;
      this.setPermissions();
    }

    setPermissions() {
		    const user = this.authenticationService.user;
		    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_BREAKDOWN_REASON_CREATE', user);
		    this.isDisabledGranted = this.authenticationService.isRoleGranted('INV_BREAKDOWN_REASON_DISABLE', user);

	  }

    beforeLoad() {
      
      this.paginationRequest.sortAsc= false;
      if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
        this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
      }
    }
  
    afterLoad() {
      
    }
    excelColumns = {};
    exportExcel() {
      this.setExcelColumns();
      let fileNameTitle = this.translateService.instant('tableManagement.breakdown.breakdownReason.title');
      super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
      const reason = (entity: any) => entity.reason ?? ''
      const disabled = (entity: any) => !entity.disabled
      this.excelColumns = {
        [this.translateService.instant('tableManagement.breakdown.breakdownReason.reason')]: { bindField: reason },
        [this.translateService.instant('general.active')]: { bindField: disabled },
      }
    }

}